import { createContext, useContext, useState } from "react";
import { fetchVehicleVPOG } from "../services/dealership";

const SelectVehicleContext = createContext(undefined);

export function SelectVehicleProvider({ children }) {
  const [vehicleVPOGUrl, setVehicleVPOGUrl] = useState("");
  // const [selctedVehicleParams, setSelectedVehicle]

  async function handleVehicleVPOG(params) {
    setVehicleVPOGUrl("");
    const response = await fetchVehicleVPOG(params);
    setVehicleVPOGUrl(response.data.url);
  }

  return (
    <SelectVehicleContext.Provider
      value={{ vehicleVPOGUrl, handleVehicleVPOG }}
    >
      {children}
    </SelectVehicleContext.Provider>
  );
}

export function useSelectVehicleContext() {
  const selectVehicleContext = useContext(SelectVehicleContext);

  if (selectVehicleContext === undefined) {
    throw new Error(
      "SelectVehicleContext must be used inside SelectVehicleProvider"
    );
  }

  return selectVehicleContext;
}

export default SelectVehicleContext;
